<template>
    <header class="header-sticky fixed header-absolute">
        <nav class="navbar navbar-expand-xl">
            <div class="container">
                <a class="navbar-brand me-0" href="/">
                    <img src="/assets/images/logovisennia.svg" alt="Logo" style="height: 60px;">
                </a>
    
                <div class="navbar-collapse collapse" id="navbarCollapse">
                    <ul class="navbar-nav navbar-nav-scroll dropdown-hover mx-auto">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link" :class="{ active: $route.path === '/' }" style="font-weight: bold;">
                                {{ $t('menu.home') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/blogs" class="nav-link" :class="{ active: $route.path === '/blogs' }" style="font-weight: bold;">
                                {{ $t('menu.blogs') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/podcasts" class="nav-link" :class="{ active: $route.path === '/podcasts' }" style="font-weight: bold;">
                                {{ $t('menu.podcasts') }}
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/contact" class="nav-link" :class="{ active: $route.path === '/contact' }" style="font-weight: bold;">
                                {{ $t('menu.contact') }}
                            </router-link>
                        </li>
                    </ul>
                </div>
    
                <!-- Langue Dropdown -->
                <ul class="nav align-items-center dropdown-hover ms-sm-2">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="languageDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-weight: bold;">
                            {{ $t('menu.langue') }}
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="languageDropdown">
                            <li>
                                <a class="dropdown-item" href="#" @click="changeLanguage('fr')">
                                    🇫🇷 Français
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="#" @click="changeLanguage('en')">
                                    🇬🇧 English
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="#" @click="changeLanguage('ar')">
                                    🇸🇦 عربي
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <button class="navbar-toggler ms-sm-3 p-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-animation">
                                <span></span>
                                <span></span>
                                <span></span>
                            </span>
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    </header>
    </template>
    
    <script>
    export default {
        methods: {
            changeLanguage(lang) {
                this.$i18n.locale = lang;
                localStorage.setItem('lang', lang);
                document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
                location.reload();
            }
        }
    }
    </script>
    